import { ESN } from '../types';
export default {
  type: ESN,
  service: 'ethersocial.org',
  url: 'https://api.esn.gonspool.com',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
